module.exports = __webpack_public_path__ + "static/media/beak.d4f7bc01.svg";